export default "__VITE_ASSET__BpkYZ1tI__"